import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const useStartTest = () => {
  const [state, setState] = useState({
    startTest: false,
    isNextPage: true,
    examMode: false,
  });
  const testDetails = useSelector((state) => state.test.testDetails?.data);
  const { id } = useParams();

  const showNextPage = () => {
    if (testDetails?.EvalutionMode && testDetails?.PracticeMode) {
      setState((state) => ({ ...state, isNextPage: false, startTest: true }));
    } else {
      setState((state) => ({ ...state, isNextPage: false, startTest: false }));
    }
  };

  const startExamHandler = () => {
    setState((state) => ({ ...state, startTest: false }));
  };

  const examModeHandler = (mode) => {
    setState((state) => ({
      ...state,
      examMode: mode === "eval" ? true : false,
    }));
  };
  return {
    showNextPage,
    startExamHandler,
    examModeHandler,
    state,
    id,
    testDetails,
  };
};

export default useStartTest;
